import type { VoidFunctionComponent } from 'react';

import { icons } from '../../../generic';
import Button, { BUTTON_TYPE } from '../../../generic/Button';
import TooltipIcon from '../../../generic/TooltipIcon';

import styles from './BranchesDropdown.module.less';

type Props = {
  isUserAuthenticated: boolean;
  defaultBranch: string;
  onTrackDefaultBranch: () => void;
};

/**
 * Displays the "track default branch" call to action.
 */
const TrackDefaultBranchCTA: VoidFunctionComponent<Props> = ({
  isUserAuthenticated,
  defaultBranch,
  onTrackDefaultBranch,
}) => {
  // Only show the "track default branch" button to authenticated users.
  const shouldShowTrackDefaultBranchButton = isUserAuthenticated;
  return (
    <div className={styles.dropdownMenuTrackDefaultBranchCTA}>
      <div className={styles.dropdownMenuTrackDefaultBranchCTAInfo}>
        <div>No branches being tracked.</div>
        <TooltipIcon
          id="branches-dropdown-track-default-branch-cta"
          icon={icons.questionCircle}
          tooltip="Tracking a branch will allow FOSSA to listen for changes (Pushes or Pull Requests) on that branch, and trigger new builds within our system."
        />
      </div>
      {shouldShowTrackDefaultBranchButton && (
        <Button
          type={BUTTON_TYPE.SECONDARY}
          testId="branches-dropdown-track-default-branch-button"
          onClick={(e) => {
            // Prevent this action from closing the branches dropdown menu.
            e.stopPropagation();
            onTrackDefaultBranch();
          }}
        >
          Track &quot;{defaultBranch}&quot; branch
        </Button>
      )}
    </div>
  );
};

export default TrackDefaultBranchCTA;
